import React from "react";
import "./Projects.css";
import college from "../../images/college.png";
import react from "../../images/e-com.png";
import flipkart from "../../images/flipkart.png";
import dogAPI from "../../images/dogApi.png";
import { theamContex } from "../../Context";
import { useContext } from "react";

// Swiper import
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function Projects() {
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="Projects"
      className="project"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
      }}
    >
      <h1>
        My Awesome <span>Projects</span>
      </h1>

      <Swiper
        spaceBetween={40}
        slidesPerView={2}
        grabCursor={true}
        className={"project-silder"}
        breakpoints={true}
      >
        <SwiperSlide>
          <img src={react} alt="" />
          <p>React E-Commerce Website</p>
          <a href="https://e-commerce-56a4c.web.app/" target="_blank">
            <button className="button">View</button>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <img src={dogAPI} alt="" />
          <p>Dog Image API</p>
          <a href="https://dipakpatil100.github.io/Dog-API/" target="_blank">
            <button className="button">View</button>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <img src={college} alt="" />
          <p>College Website</p>
          <a href="http://college-webpage.rf.gd/home.html" target="_blank">
            <button className="button">View</button>
          </a>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Projects;
